var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('v-container',{attrs:{"fluid":""}},[_c('Alert'),_c('dialog-update-employee'),_c('v-row',{attrs:{"align":"center","align-content":"center","justify":"center"}},[_c('table-campaign')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }